var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6551 12.7301L19.9551 22.4301L10.2551 12.7301C10.0236 12.4986 9.74882 12.315 9.44641 12.1897C9.144 12.0645 8.81988 12 8.49255 12C8.16523 12 7.8411 12.0645 7.53869 12.1897C7.23628 12.315 6.96151 12.4986 6.73005 12.7301C6.4986 12.9615 6.315 13.2363 6.18973 13.5387C6.06447 13.8411 6 14.1652 6 14.4926C6 14.8199 6.06447 15.144 6.18973 15.4464C6.315 15.7488 6.4986 16.0236 6.73005 16.2551L18.2051 27.7301C19.1801 28.7051 20.7551 28.7051 21.7301 27.7301L33.205 16.2551C33.4368 16.0238 33.6207 15.749 33.7461 15.4466C33.8716 15.1442 33.9362 14.82 33.9362 14.4926C33.9362 14.1651 33.8716 13.8409 33.7461 13.5385C33.6207 13.2361 33.4368 12.9613 33.205 12.7301C32.2301 11.7801 30.6301 11.7551 29.6551 12.7301Z",
    fill: "#AEB0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.0d3a30193c8c8899fb71b3199c59c423.svg";
export { ForwardRef as ReactComponent };